import { WWOTopAdDestinationsTable } from "app/pages/website-performance/components/TopAdDestinations/WWOTopAdDestinationsTable";

export const WWOTopAdDestinationsContainerSI = ({ hideFooter = true }: { hideFooter?: boolean }) => {
    return (
        <WWOTopAdDestinationsTable
            getCtaLink={() => ({ href: "", target: "_self" })}
            hideFooter={hideFooter}
        />
    );
};
